import { configure } from 'mobx';
import { createContext, useContext } from 'react';
import { LoginSessionStore } from './general/loginSessionStore';
import { NotificationStore } from './general/notificationStore';
import { RequestProcessor } from './general/requestProcessor';
import AnnouncementStore from './domain/announcementStore';
import RegistrationStore from './ui-stores/registration/registrationStore';
import ForgotPasswordStore from './ui-stores/forgot-password/forgotPasswordStore';
import ResetPasswordStore from './ui-stores/reset-password/resetPasswordStore';
import AaaStore from './domain/aaaStore';
import RoleTypeAndAgencyStore from './ui-stores/sign-in/roleTypeAndAgencyStore';
import SignInFormStore from './ui-stores/sign-in/signInFormStore';

configure({
  useProxies: 'never',
  computedRequiresReaction: true,
  reactionRequiresObservable: true,
  observableRequiresReaction: true,
});

export class RootStore {
  // General
  notificationStore: NotificationStore;
  loginSessionStore: LoginSessionStore;
  requestProcessor: RequestProcessor;

  // Domain
  announcementStore: AnnouncementStore;
  aaaStore: AaaStore;

  // UI-Stores
  signInFormStore: SignInFormStore;
  roleTypeAndAgencyStore: RoleTypeAndAgencyStore;
  registrationStore: RegistrationStore;
  forgotPasswordStore: ForgotPasswordStore;
  resetPasswordStore: ResetPasswordStore;

  constructor() {
    // Domain
    this.announcementStore = new AnnouncementStore();
    this.aaaStore = new AaaStore();

    // General
    this.notificationStore = new NotificationStore();
    this.loginSessionStore = new LoginSessionStore(this);
    this.requestProcessor = new RequestProcessor(this);

    // UI-Stores
    this.signInFormStore = new SignInFormStore(this);
    this.roleTypeAndAgencyStore = new RoleTypeAndAgencyStore(this);
    this.registrationStore = new RegistrationStore(this);
    this.forgotPasswordStore = new ForgotPasswordStore(this);
    this.resetPasswordStore = new ResetPasswordStore(this);
  }
}

const rootStore = new RootStore();

export function getRootStoreInstance(): RootStore {
  return rootStore;
}

const RootContext = createContext(rootStore);

export const useRootStore = (): RootStore => {
  return useContext(RootContext);
};

export { RootContext };
